import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@material-ui/core';
import { withSnackbar } from 'notistack';
import { trackActivity } from '../../../utils/mixpanel';
import { CustomDropzone, DeletePopUp, PreviewDocsModal } from '../../../shared_elements';
import { addAttachmentApi, deleteAttachmentApi } from '../apiServices';
import { regexConstants } from '../../../constants/regEx';
import { titanAviInstance } from '../../../shared_elements/components';

class ApproveDialog extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modal: false,
      shopVisit: {},
      approveData: [],
      error: {},
      previewDocs: "",
      deleteItem: "",
      deleteAttachmentModal: false,
      attachedDoc: [],
      pageLoader: false,
    }
    this.deleteAttachmentApi = deleteAttachmentApi.bind(this);
    this.addAttachmentApi = addAttachmentApi.bind(this);
  }
  updateErrorField = (key, message) => {
    this.setState(prevState => ({
      ...prevState,
      error: {
        ...prevState.error,
        [key]: message
      }
    }))
  }
  onFieldChange = (keyParam, value) => {
    this.setState(prevState => ({
      ...prevState,
      shopVisit: {
        ...prevState.shopVisit,
        [keyParam]: value
      }
    }))
  }
  
  getResponseBack = () => {
    this.setState({ modal: false, error: {}, shopVisit: {} })
  }

  addReason = () => {
    const { shopVisit, } = this.state
    const { item, pageTitle} = this.props
    let validationInputs = {
      comment: shopVisit?.comment ? "" : "Please enter Approval Comment",
    }
    if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
      if (this.state.attachedDoc?.length > 10) {
        this.props.enqueueSnackbar('Only 10 attachment can be attached in one time.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        return;
      }
      if (this.state.attachedDoc?.length + shopVisit?.attachments?.length > 50) {
        this.props.enqueueSnackbar('Only 50 attachment can be attached.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        return;
      }
      if(pageTitle === "Claims"){
        if (titanAviInstance) {
          this.props.changeStatus({ approved_status:  { value: 2, label: "Approved" }, comment: shopVisit?.comment }, { props: this.props, isAttachment: true, attachedDoc: this.state.attachedDoc, toggleFnc: this.toggleFnc, getResponseBack: this.getResponseBack })
        } else {
          this.props.changeStatus({ status: item.status.value === 2 ? 3 : 2, comment: shopVisit?.comment }, { props: this.props, isAttachment: true, attachedDoc: this.state.attachedDoc, toggleFnc: this.toggleFnc, getResponseBack: this.getResponseBack })
        }
      }else{
        this.props.changeStatus({ status: item?.status?.value == 7 ? 3 : 5, comment: shopVisit?.comment, claim_approval_period:shopVisit?.claim_approval_period },{props : this.props,isAttachment :true,attachedDoc :this.state.attachedDoc,toggleFnc : this.toggleFnc,getResponseBack : this.getResponseBack}) 
      }
      trackActivity('Added Approved Reason', {
        page_title: this.props.pageTitle,
        asset_slug: this.props.match.params.assetSlug,
        asset_type: this.props.match.params.assetType,
        assembly_type: this.props.assemblyType,
      })
    }else {
      this.setState({ error: validationInputs });
    }
  }
  toggleFnc = (key, status) => {
    this.setState({ [key]: status })
  }
  onAttachmentDelete = () => {
    this.setState(prevState => ({
      ...prevState,
      shopVisit: {
        ...prevState.shopVisit,
        attachments: this.state.shopVisit?.attachments?.filter(item => item.uuid !== this.state.deleteItem.uuid)
      }
    }))
    this.deleteAttachmentApi(this.state.deleteItem, "shopvisit", this.props.id, this.toggleFnc)
  }
  render() {
    const { item, pageTitle } = this.props
    const { modal, error, shopVisit, pageLoader } = this.state
    return (
      <Fragment>
        <Button onClick={() => this.setState({ modal: true, shopVisit: item }, () => trackActivity('Item Clicked', { page_title: this.props.pageTitle, item_type: 'Reject', assembly_type: this.props.assemblyType }))} color="primary"
          variant="outlined" size='small'>Approve</Button>
        {modal ?
          <Dialog
            open={modal}
            onClose={() => this.setState({ modal: false, error: {} })}
            aria-labelledby="scroll-dialog-title"
          >
            <DialogTitle id="scroll-dialog-title">
              Approval Comment
            </DialogTitle>
            <DialogContent dividers={true} style={{ minWidth: '400px' }}>
              <Grid container spacing={2}>
               { pageTitle=== 'shopVisit' && item?.status?.value===7?
                <Grid item xs={12}>
                  <TextField
                    label="Claim Validity Period (Days)"
                    id="claim_approval_period"
                    fullWidth
                    margin="normal"
                    value={shopVisit?.claim_approval_period||''}
                    onFocus={() => this.updateErrorField('claim_approval_period', '')}
                    onChange={(e) => regexConstants.numberNoSpace.test(e.target.value) ? this.onFieldChange('claim_approval_period', e.target.value) : e.preventDefault()}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid> :null}
                <Grid item xs={12}>
                  <TextField
                    label="Approval Comment"
                    required
                    id="comment"
                    fullWidth
                    margin="normal"
                    multiline
                    rows="4"
                    value={shopVisit?.comment}
                    onFocus={() => this.updateErrorField('comment', '')}
                    onChange={(e) => this.onFieldChange('comment', e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    error={error?.comment ? true : false}
                    helperText={error?.comment ? error.comment : ''}
                  />
                </Grid>
                <Grid item xs={12} style={{ marginBottom: '5px' }} className='drag-drop'>
                  <CustomDropzone
                    onChange={(files) => this.setState({ attachedDoc: files })}
                    componentData={this.state.approveData}
                    attachedDoc={this.state.attachedDoc}
                    filesLimit={3}
                    filesLimitNote="Only pdf, docx, xls, xlsx, jpg, jpeg and png files are supported.(You can upload maximum limit of 3 files.)"
                  >
                  </CustomDropzone>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.setState({ modal: false }, () => trackActivity('Item Clicked', { page_title: this.props.pageTitle, item_type: 'Rejection Modal', assembly_type: this.props.assemblyType }))} className='mr-5' variant='outlined' size='small'   color="primary">Cancel</Button>
              <Button size='small' variant="contained" onClick={this.addReason} color="primary">{pageLoader ? <CircularProgress color="#ffffff" size={24} /> : 'Save'}</Button>
            </DialogActions>
          </Dialog> : null
        }
        {this.state.previewDocs ? <PreviewDocsModal previewDocs={this.state.previewDocs} toggleModalFn={() => this.setState({ previewDocs: '' })} /> : null}
        {this.state.deleteAttachmentModal ?
          <DeletePopUp
            loader={this.state.buttonLoader}
            modal={this.state.deleteAttachmentModal}
            toggleModalFn={() => this.setState({ deleteAttachmentModal: false })}
            title="Delete Attachment"
            content={<h4>Are you sure you want to delete?</h4>}
            deleteRecordFn={() => this.onAttachmentDelete()}
          /> : null
        }
      </Fragment>

    )
  }
}
export default withSnackbar(withRouter(ApproveDialog));
